import * as React from "react";
import DeletePanel from "../../components/CustomDelete/DeletePanel";
import strings from "../../config/localization";
import { useDeleteBandobastMutation } from "../../services/appln";

export default function DeleteBandobast(props: any): any {
  return (
    <DeletePanel
      useIcon={true}
      deleteMutation={useDeleteBandobastMutation}
      deleteArgs={{ id: props.id }}
      buttonLabel={strings.delete}
      confirmationDialogTitle={strings.deleteBandobastTitle}
      confirmationDialogMsg={strings.deleteBandobastConfirmation}
      errorDialogTitle={strings.deleteBandobastFailedTitle}
      errorDialogMsg={strings.deleteBandobastFailedMsg}
    />
  );
}
